import React from "react"
import { navigate } from "vike/client/router"
import Typography from "aldoo-ra/Typography"
import ReadTimeBadge from "./read-time-badge"

const PostCard = ({ post }) => {
  // Post URL
  const href = `/blog/${post.slug}`

  const formatDate = (dateString) => {
    const date = new Date(dateString || "2024-10-23")
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
    })
  }

  return (
    <a href={href} className="flex flex-col cursor-pointer group">
      {/* Image Container */}
      <div className="relative w-full aspect-[2.07] rounded-[24px] overflow-hidden bg-gray_100 mb-6 md:mb-[30px]">
        {/* Read Time Badge */}
        <ReadTimeBadge data={post} top="4" topMd="4" right="4" rightMd="5" />

        <img
          src={post.thumbnail}
          alt={post.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>

      {/* Content */}
      <div className="flex flex-col gap-[15px]">
        {/* Date */}
        <Typography variant="txt1_dim" className="my-0">
          {formatDate(post.publish_date)}
        </Typography>

        {/* Title */}
        <Typography variant="body1_accent" className="my-0">
          {post.title}
        </Typography>
      </div>
    </a>
  )
}

export default PostCard
